function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Input, Icon, InputGroup, InputLeftElement, InputRightElement, Spinner } from '@chakra-ui/react';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function SearchInput(_param) {
    var search = _param.search, setSearch = _param.setSearch, placeholder = _param.placeholder, inputProps = _param.inputProps, _param_isSearching = _param.isSearching, isSearching = _param_isSearching === void 0 ? false : _param_isSearching, props = _object_without_properties(_param, [
        "search",
        "setSearch",
        "placeholder",
        "inputProps",
        "isSearching"
    ]);
    var isMobile = window.innerWidth < 768;
    return /*#__PURE__*/ _jsxs(InputGroup, _object_spread_props(_object_spread({
        size: "sm",
        width: "auto"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Input, _object_spread({
                id: "search",
                autoFocus: !isMobile,
                "data-1p-ignore": true,
                borderWidth: 1,
                borderColor: "borderTertiary",
                boxShadow: "sm",
                borderRadius: "lg",
                placeholder: placeholder,
                value: search,
                onChange: function(param) {
                    var value = param.target.value;
                    return setSearch(value);
                },
                backgroundColor: "backgroundPrimary",
                _focus: {
                    borderColor: 'borderTertiary',
                    backgroundColor: 'backgroundPrimary'
                }
            }, inputProps)),
            /*#__PURE__*/ _jsx(InputLeftElement, {
                children: /*#__PURE__*/ _jsx(Icon, {
                    as: FontAwesomeIcon,
                    icon: faMagnifyingGlass
                })
            }),
            /*#__PURE__*/ _jsx(InputRightElement, {
                children: /*#__PURE__*/ _jsx(Spinner, {
                    size: "sm",
                    color: "textSecondary",
                    display: isSearching ? 'block' : 'none'
                })
            })
        ]
    }));
}
export default SearchInput;
